import { authStore } from '../stores/authStore';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';

export const usePermissions = () => {
  const navigate = useNavigate();
  const { user, hasPermission } = authStore();

  const checkPermission = (module, action = 'view') => {
    const hasAccess = hasPermission(module, action);
    
    if (!hasAccess) {
      toast.error('Você não tem permissão para acessar este recurso');
      navigate('/');
      return false;
    }
    
    return true;
  };

  const canView = (module) => hasPermission(module, 'view');
  const canCreate = (module) => hasPermission(module, 'create');
  const canEdit = (module) => hasPermission(module, 'edit');
  const canDelete = (module) => hasPermission(module, 'delete');

  const isAdmin = () => user?.cargo?.nome?.toLowerCase().includes('admin');
  const isTecnico = () => user?.cargo?.nome?.toLowerCase().includes('técnico');
  const isAtendente = () => user?.cargo?.nome?.toLowerCase().includes('atendente');

  return {
    checkPermission,
    canView,
    canCreate,
    canEdit,
    canDelete,
    isAdmin,
    isTecnico,
    isAtendente,
    hasPermission
  };
};